define('viewmodels/modals/dialogs/TicketDialog',[],function () {

    var CouponDialog = function(dialog, ticketContent) {

        this.ticketContent = ticketContent;
        this.dialog = dialog;
    };

    CouponDialog.prototype.close = function() {
        this.dialog.close(this);
    };

    return CouponDialog;
});

